import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormHelperText,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme, _params, classes) => ({
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

const validationSchema = yup.object({
  comment: yup.string().trim().required("Comment is required."),
});

function EditCommentsDialog({ file, handleUpdateFile, onClose }) {
  const { classes } = useStyles();
  const initialValues = {
    comment: file["comment"],
  };

  function onSubmit(values, { resetForm }) {
    handleUpdateFile({ id: file["id"], comment: values["comment"] });
    onClose();
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit,
  });

  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        style: {
          maxWidth: "sm",
        },
      }}>
      <DialogTitle variant="h6" sx={{ display: "flex", alignItems: "center" }}>
        Add Comment
      </DialogTitle>
      <DialogContent>
        <form>
          <TextField
            fullWidth
            sx={{ marginTop: 1 }}
            variant="outlined"
            label="Comment"
            name="comment"
            error={Boolean(formik.errors.comment)}
            value={formik.values.comment}
            onChange={formik.handleChange}
          />
          {formik.errors.comment && (
            <FormHelperText error sx={{ ml: 1 }}>
              {formik.errors.comment}
            </FormHelperText>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          <span className={classes.gradientText}>Cancel</span>
        </Button>
        <Button
          onClick={formik.handleSubmit}
          variant="contained"
          color="primary"
          disabled={formik.isSubmitting || !formik.dirty || !formik.isValid}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditCommentsDialog;
